import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Checkbox, Form } from 'semantic-ui-react';
import { CustomCheckbox, CategoryContainer } from './styles';

const Selector = (props) => {
  if (props.withCategories) {
    return (
      <>
        {!_.isEmpty(props.checked) && props.values.map((category) => {
          let categoryIsChecked = false;
          if (props.checked) {
            if (_.keys(category)[0] === 'Any') {
              categoryIsChecked = props.checked.Any;
            } else {
              categoryIsChecked = props.checked[_.keys(category)[0]].allStates;
            }
          }
          return (
            <CategoryContainer key={_.keys(category)[0]}>
              <Form.Field>
                <Checkbox
                  name={_.keys(category)[0]}
                  label={_.keys(category)}
                  onChange={(e, obj) => props.onChange(e, obj, _.keys(category)[0])}
                  value={_.keys(category)[0]}
                  checked={categoryIsChecked}
                />
              </Form.Field>
              {category[_.keys(category)].map((item) => {
                let stateIsChecked = false;
                if (props.checked) {
                  stateIsChecked = props.checked[_.keys(category)[0]].states[item.value];
                }
                return (
                  <Form.Field key={item.text}>
                    <CustomCheckbox
                      name={item.text}
                      label={item.text}
                      onChange={(e, obj) => props.onChange(e, obj, _.keys(category)[0])}
                      value={item.value}
                      checked={stateIsChecked}
                    />
                  </Form.Field>
                );
              })}
            </CategoryContainer>
          );
        })}
      </>
    );
  }
  return (
    <>
      {props.values.map((item) => (
        <Form.Field key={item}>
          <Checkbox
            name={item}
            label={item}
            onChange={(e, obj) => props.onChange(e, obj)}
            value={item}
            checked={_.has(_.pickBy(props.checked, (isChecked) => isChecked === true), item)}
          />
        </Form.Field>
      ))}
    </>
  );
};

Selector.propTypes = {
  withCategories: PropTypes.bool,
  checked: PropTypes.object.isRequired,
  values: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

Selector.defaultProps = {
  withCategories: false,
};

export default Selector;
